import api from 'lib/trpcClient';

export default function useFeeTemplateOptions(
  vehicleId: string,
  refetchOnWindowFocus?: boolean,
) {
  const [lpFeeTemplates] = api.lpFeeTemplate.list.useSuspenseQuery(
    {
      vehicleId,
    },
    {
      refetchOnWindowFocus: refetchOnWindowFocus ? 'always' : false,
    },
  );

  return lpFeeTemplates.map((template) => ({
    value: template.id,
    label: template.name,
  }));
}
